var map = {
	"./Bacillocid Extra.jpg": 9185,
	"./Bacillocil Special.jpg": 8568,
	"./Bactorub Blue.jpg": 4861,
	"./Kohrsolin Th.jpg": 9828,
	"./Korsolex Rapid.jpg": 4239,
	"./Mikrobac Forte.jpg": 4339,
	"./Sterillium.jpg": 4643
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 186;